var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pages),function(page){return _c('canvas',{key:_vm.tabIndex + _vm.subIndex + page,staticStyle:{"width":"100%"},attrs:{"id":_vm.tabIndex + _vm.subIndex + 'the-canvas'+page}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b20b19e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdfbox.vue
// module id = null
// module chunks = 